// import find from 'lodash/find';
import forEach from 'lodash/forEach';
import map from 'lodash/map';
import moment from 'moment';
import React from 'react';
import {connect} from 'react-redux';
import {
  getDailyReportAcquisition,
  getDailyReportFreemium,
  getDailyReportLoyalty,
} from '../../actions/entities/dailyReport';
import './index.css';

class DailyReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentMonth: ~~moment().format('M'),
      previousPercentageAcquisition: 0,
      step: 0,
    };
  }

  loadDailyReport = refresh => {
    const {dispatch} = this.props;
    this.setState({step: 1});
    dispatch(getDailyReportAcquisition(refresh));
    dispatch(getDailyReportLoyalty(refresh));
    dispatch(getDailyReportFreemium(refresh));
  };

  componentDidMount() {
    this.loadDailyReport(false);
  }

  renderProgression({data, isFetching}, type) {
    console.log(data, type);
    const {currentMonth} = this.state;
    const countries = ['FR', 'ES', 'OTHER'];
    const totalName = {
      Acquisition: 'Total new',
      FID: 'Total Active Users',
      Freemium: 'Total Paid Users',
    };
    let previousPercentage = 0;
    let totalPrevious = null;
    // let currentPercentage = null;
    // let currentNbUsers = null;
    // let current = null;
    let previous = null;

    console.log('DATA', data);
    if (data) {
      // current = data.current;
      previous = data.past;
      forEach(previous, ({usersQuantity}) => (totalPrevious += usersQuantity));
    }

    return (
      <div>
        <h1 className="text-center">{type}</h1>
        {data && !isFetching ? (
          <React.Fragment>
            <div className="progressionContainer">
              <div className="period">
                <h3 className="text-center">Today</h3>
                <div>
                  <div
                    style={{fontWeight: 500, fontSize: '16px'}}
                    className="progressionContainer">
                    <div className="todayEntry">{totalName[type]}</div>
                    <div>
                      {data?.currentSeasonStats?.total?.toLocaleString() || 0}
                    </div>
                  </div>
                  {type === 'Acquisition' && (
                    <div
                      style={{fontStyle: 'italic', fontSize: '12px'}}
                      className="progressionContainer">
                      <div className="todayEntry">Daily average</div>
                      <div>
                        {data?.currentSeasonStats?.dailyAverage?.toLocaleString() ||
                          0}
                      </div>
                    </div>
                  )}
                  {countries.map(c => (
                    <React.Fragment>
                      <div className="progressionContainer">
                        <div className="todayEntry">{c}</div>
                        <div>
                          {data.currentSeasonStats?.[
                            c
                          ]?.usersQuantity?.toLocaleString() || 0}
                        </div>
                      </div>
                      {type === 'FID' && (
                        <React.Fragment>
                          <div
                            style={{fontStyle: 'italic'}}
                            className="progressionContainer">
                            <div
                              style={{textAlign: 'center'}}
                              className="todayEntry">
                              Old
                            </div>
                            <div>
                              {data.currentSeasonStats?.countries?.[
                                c
                              ]?.pastUsers?.toLocaleString() || 0}
                            </div>
                          </div>
                          <div
                            style={{fontStyle: 'italic'}}
                            className="progressionContainer">
                            <div
                              style={{textAlign: 'center'}}
                              className="todayEntry">
                              New
                            </div>
                            <div>
                              {data.currentSeasonStats?.countries?.[
                                c
                              ]?.newUsers?.toLocaleString() || 0}
                            </div>
                          </div>
                        </React.Fragment>
                      )}
                    </React.Fragment>
                  ))}
                </div>
              </div>
              <div style={{marginBottom: '70px'}} className="period">
                <h3 className="text-center">Total season</h3>
                <div>
                  <div className="progressionBar">
                    {map(previous, ({usersQuantity, month}) => {
                      const position = (usersQuantity / totalPrevious) * 100;
                      // if (month === currentMonth) {
                      // currentNbUsers = find(current, { month }).usersQuantity;
                      // currentPercentage = currentNbUsers / usersQuantity * 100;
                      // }
                      previousPercentage += position;
                      return (
                        <React.Fragment>
                          <div
                            style={{
                              zIndex: 2,
                              left: `${
                                month === previous[0].month
                                  ? position
                                  : previousPercentage
                              }%`,
                            }}
                            className="bar">
                            <div
                              style={
                                month % 2 === 0
                                  ? {top: '-20px'}
                                  : {bottom: '-20px'}
                              }
                              className="month">
                              {month}
                            </div>
                          </div>
                          {currentMonth === month && (
                            <div
                              style={{
                                zIndex: 2,
                                marginTop: '-3px',
                                height: '56px',
                                width: '3px',
                                left: `${
                                  (data.pastSeasonStats.total / totalPrevious) *
                                  100
                                }%`,
                              }}
                              className="bar"
                            />
                          )}
                          {month === currentMonth && (
                            <div
                              className="currentProg"
                              style={{
                                width: `${
                                  data.currentSeasonStats.total >= totalPrevious
                                    ? 100
                                    : (data.currentSeasonStats.total /
                                        totalPrevious) *
                                      100
                                }%`,
                                backgroundColor: `${
                                  data.currentSeasonStats.total >=
                                  data.pastSeasonStats.total
                                    ? 'green'
                                    : 'orange'
                                }`,
                                left: 0,
                              }}>
                              {/*<div style={{ fontWeight: 'bold', marginTop: '75px' }}>*/}
                              {/*<div>{currentNbUsers.toLocaleString()}</div>*/}
                              {/*</div>*/}
                            </div>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </div>
                </div>
              </div>
              <div className="period">
                <h3 className="text-center">VS n-1 Season</h3>
                <div style={{fontSize: '18px'}} className="text-center">
                  <div
                    style={{
                      color:
                        data.currentSeasonStats.total >=
                        data.pastSeasonStats.total
                          ? 'green'
                          : 'orange',
                    }}>
                    {Math.round(
                      ((data.currentSeasonStats.total -
                        data.pastSeasonStats.total) /
                        data.pastSeasonStats.total) *
                        100,
                    )}
                    %
                  </div>
                  <div>
                    {data?.pastSeasonStats?.total
                      ? data?.pastSeasonStats?.total?.toLocaleString()
                      : 0}
                  </div>
                </div>
              </div>
            </div>
            {type === 'Freemium' && data.arpu && (
              <div className="arpuContainer p-5">
                <div className="arpuContent text-center">
                  <h3 className="text-center">ARPU Freemium</h3>
                  <div style={{fontWeight: 'bold', fontSize: '16px'}}>
                    {data.arpu.current}€
                  </div>
                </div>
                {data.arpu.past && (
                  <div className="arpuContent text-center">
                    {data.arpu.current && (
                      <div
                        style={{
                          color:
                            data.arpu.current >= data.arpu.past
                              ? 'green'
                              : 'orange',
                          fontSize: '18px',
                        }}
                        className="text-center">
                        {Math.round(
                          ((data.arpu.current - data.arpu.past) /
                            data.arpu.past) *
                            100,
                        )}
                        %
                      </div>
                    )}
                    <div style={{fontWeight: 'bold', fontSize: '16px'}}>
                      {data.arpu.past}€
                    </div>
                  </div>
                )}
              </div>
            )}
          </React.Fragment>
        ) : (
          <h1 className="text-center">
            <i className="fa fa-spin fa-circle-o-notch" />
          </h1>
        )}
      </div>
    );
  }

  render() {
    const {acquisition, loyalty, freemium} = this.props;
    return (
      <div id="daily-report">
        <section className="content">
          <div className="box box-default">
            <button
              style={{position: 'absolute'}}
              onClick={() => this.loadDailyReport(true)}
              className="btn btn-success m-3">
              Refresh
            </button>
            {this.renderProgression(acquisition, 'Acquisition')}
            {this.renderProgression(loyalty, 'FID')}
            {this.renderProgression(freemium, 'Freemium')}
          </div>
        </section>
      </div>
    );
  }
}

export default connect(
  state => ({
    acquisition: state.app.dailyReport.acquisition,
    loyalty: state.app.dailyReport.loyalty,
    freemium: state.app.dailyReport.freemium,
  }),
  dispatch => ({dispatch}),
)(DailyReport);



// WEBPACK FOOTER //
// ./src/pages/DailyReport/index.js